import { useMemo } from 'react';

import { useAuth } from '../../hooks';

export type EpsiAcl = {
  epsiActionSynchronize: boolean;
  epsiActionRetry: boolean;
};

/**
 * Oprávnění akcí EPSI na jednom místě, ať se přehled a detail nerozejdou —
 * retry se nabízí z obou.
 *
 * TODO: ACL resource `EpsiDocs` zatím akce `synchronize`/`retry` nezná, proto
 * jsou natvrdo povolené a kontrola stojí jen na 403 z API. Až BE oprávnění
 * doplní, stačí odkomentovat.
 */
export const useEpsiAcl = (): EpsiAcl => {
  const auth = useAuth();

  return useMemo(
    () => ({
      epsiActionSynchronize: true, //auth.hasPermission('EpsiDocs', 'synchronize', null),
      epsiActionRetry: true, //auth.hasPermission('EpsiDocs', 'retry', null),
    }),
    [auth],
  );
};
